export const API_TOKEN = "token/";
export const API_USERS = "users/";
export const API_COUNTRIES = "countries/";
export const API_CITIES = "cities/";
export const API_WALLETS = "wallets/";
export const API_PROFILE_ME = "profile/me/";
export const API_WALLET_TRANSFER = "wallet/transfer/";
export const API_TRANSACTIONS = "transactions/";
export const API_LOANS = "loans/";
export const API_LOANS_DURATIONS = "loan-duration-options/";
export const API_LOAN_PRODUCTS = "loan-products/";
export const API_PASSWORD_RESET = "password_reset/";
export const API_VERIFY_EMAIL = "users/verify-email/";

// AutoInvest (managed investment) — Phase 1
export const API_AUTOINVEST = "autoinvest/";
export const API_AUTOINVEST_PRODUCTS = "autoinvest/products/";

// Phone + OTP auth
export const API_OTP_REQUEST = "auth/otp/request/";
export const API_OTP_VERIFY_LOGIN = "auth/otp/verify-login/";
export const API_OTP_VERIFY_SIGNUP = "auth/otp/verify-signup/";
export const API_OTP_RESET_PASSWORD = "auth/otp/reset-password/";

// Email OTP — for verifying the authenticated user's email address
export const API_EMAIL_OTP_REQUEST = "auth/email-otp/request/";
export const API_EMAIL_OTP_VERIFY = "auth/email-otp/verify/";

// Notification preferences (per-channel × per-category toggles)
export const API_NOTIFICATION_PREFERENCES = "me/notification-preferences/";

// Account deletion (request → 30-day grace → admin purge)
export const API_DELETE_REQUEST = "me/delete-request/";
export const API_MY_INVESTMENTS = "users/my-investments/";
export const API_WALLET_TRANSFER_PREVIEW = "wallet/internal/transfer/preview/";
export const API_WALLET_TRANSFER_CONFIRM = "wallet/internal/transfer/confirm/";

// Borrower dashboard
export const API_DASHBOARD_BORROWER = "dashboard/borrower/";

// Investor dashboard
export const API_DASHBOARD_INVESTOR = "dashboard/investor/";

// Device financing
export const API_DEVICES = "devices/";
export const API_DEVICE_ORDERS = "device-orders/";
export const API_DEVICE_ORDERS_CREATE = "device-orders/create/";

// Notifications
export const API_NOTIFICATIONS = "notifications/";

// Manual Deposits (consumer)
export const API_MANUAL_DEPOSITS = "manual-deposits/";
export const API_DEPOSIT_ACCOUNTS = "deposit-accounts/";
 
// Manual Withdrawals (consumer)
export const API_MANUAL_WITHDRAWALS = "manual-withdrawals/";
 
// Manual Repayments (consumer)
export const API_MANUAL_REPAYMENTS_MY = "manual-repayments/my/";
export const API_MANUAL_REPAYMENTS_SUBMIT = "manual-repayments/submit/";
 
// User Bank & MoMo Accounts
export const API_USER_BANK_ACCOUNTS = "user-bank-accounts/";
export const API_USER_MOMO_ACCOUNTS = "user-momo-accounts/";
export const API_UGANDAN_BANKS = "ugandan-banks/";
// Transaction PIN (4-digit money-out confirmation)
export const API_TRANSACTION_PIN = "me/transaction-pin/";
export const API_TRANSACTION_PIN_SET = "me/transaction-pin/set/";
export const API_TRANSACTION_PIN_FORGOT = "me/transaction-pin/forgot/";
export const API_TRANSACTION_PIN_RESET = "me/transaction-pin/reset/";
// Server-side logout (refresh-token blacklist)
export const API_LOGOUT = "auth/logout/";
// Institution (business) profile + KYC
export const API_BUSINESS = "business/";
